import { jsx as _jsx } from "react/jsx-runtime";
// @ts-nocheck
import { createContext, useContext, useEffect, useState } from 'react';
import { getSupabaseClient } from '@em-cms/db';
const AuthContext = createContext(undefined);
export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [currentSite, setCurrentSiteState] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem('cms_current_site') || 'null');
        }
        catch {
            return null;
        }
    });
    const [enabledModules, setEnabledModules] = useState([]);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const [avatarUrl, setAvatarUrl] = useState('');
    const [fullName, setFullName] = useState('');
    const supabase = getSupabaseClient();
    async function checkSuperAdmin(userId) {
        const { data } = await supabase.from('cms_users').select('is_super_admin, avatar_url, full_name').eq('id', userId).maybeSingle();
        setIsSuperAdmin(data?.is_super_admin ?? false);
        setAvatarUrl(data?.avatar_url ?? '');
        setFullName(data?.full_name ?? '');
    }
    function setCurrentSite(site) {
        setCurrentSiteState(site);
        if (site) {
            localStorage.setItem('cms_current_site', JSON.stringify(site));
            const modules = site.settings?.enabled_modules;
            setEnabledModules(Array.isArray(modules) ? modules : []);
        }
        else {
            localStorage.removeItem('cms_current_site');
            setEnabledModules([]);
        }
    }
    useEffect(() => {
        // Initialize enabledModules from currentSite on mount
        if (currentSite) {
            const modules = currentSite.settings?.enabled_modules;
            setEnabledModules(Array.isArray(modules) ? modules : []);
        }
    }, []);
    useEffect(() => {
        // Check active session
        supabase.auth.getSession().then(async ({ data: { session } }) => {
            setUser(session?.user ?? null);
            if (session?.user) {
                checkSuperAdmin(session.user.id);
            }
            setIsLoading(false);
        });
        // Listen for auth changes
        const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
            setUser(session?.user ?? null);
            if (session?.user)
                checkSuperAdmin(session.user.id);
            else
                setIsSuperAdmin(false);
        });
        return () => subscription.unsubscribe();
    }, []);
    const signIn = async (email, password, rememberMe = false) => {
        const { error } = await supabase.auth.signInWithPassword({
            email,
            password,
            options: {
                expiresIn: rememberMe ? 2592000 : 3600,
            },
        });
        return { error };
    };
    const signUp = async (email, password, fullName) => {
        const { error } = await supabase.auth.signUp({
            email,
            password,
            options: {
                data: { full_name: fullName }
            }
        });
        return { error };
    };
    const signOut = async () => {
        await supabase.auth.signOut();
        setCurrentSite(null);
    };
    const resetPassword = async (email) => {
        const { error } = await supabase.auth.resetPasswordForEmail(email, {
            redirectTo: `${window.location.origin}/reset-password`,
        });
        return { error };
    };
    return (_jsx(AuthContext.Provider, { value: {
            user,
            isLoading,
            signIn,
            signUp,
            signOut,
            resetPassword,
            currentSite,
            setCurrentSite,
            enabledModules,
            isSuperAdmin,
            avatarUrl,
            fullName,
        }, children: children }));
}
export function useAuth() {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within AuthProvider');
    }
    return context;
}
